<template>
  <div class="dh-box">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, index) in state.dhlist"
        :key="index + '-list'"
        :border="false"
      >
        <template #value>
          <span>{{ item.key }}</span>
          <div v-for="data in item.items">
            <span>+{{ data.number }}余额</span> <span>{{ data.time }}</span>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getGiftRecord } from "@/api/task";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
export default {
  name: "dhm",
  setup() {
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      dhlist: [],
      oldDhlist: [],
      loading: false,
      finished: false,
    });
    // location.reload();
    onMounted(() => {
      // onLoad();
    });

    var pagecode = 1;
    var totalPage = 1;
    const onLoad = () => {
      getGiftRecord({
        // uid: localStorage.getItem("uid"),
        uid: getQueryString("uid"),
      }).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          state.oldDhlist = state.oldDhlist.concat(res.data.data.lists);
          //
          let month = state.oldDhlist;
          let groupDate = month.reduce((groups, item) => {
            let date = new Date(item.time);
            // console.log(date)
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let ym = "" + year + "年" + month + "月";
            if (!groups[ym]) {
              groups[ym] = [];
            }
            groups[ym].push(item);
            // console.log(groups)
            return groups;
          }, {});
          const groupedArray = Object.entries(groupDate).map(([key, items]) => {
            return { key, items };
          });
          state.dhlist = groupedArray;
          console.log(state.dhlist);
          pagecode++;
          if (pagecode >= totalPage) {
            state.finished = true;
            return;
          }
          state.loading = false;
        } else {
          state.finished = true;
          Toast(res.data.msg);
          return;
        }
        state.loading = false;
      });
    };

    return {
      state,
      onLoad,
    };
  },
};
</script>

<style scoped>
.dh-box {
  min-height: 100vh;
  background-color: #f7f8fa;
  /* padding: 0 32px; */
  padding-top: 30px;
}

.dh-top {
  margin-top: 130px;
}

.van-cell {
  /* margin-top: 80px; */
  padding: 0 32px;
  background-color: #f7f8fa;
}

.van-cell__value span {
  margin-bottom: 20px;
  color: #333;
}

.van-cell__value div {
  background-color: #fff;
  height: 88px;
  width: 100%;
  border-radius: 16px;
  padding: 0 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
